import React from 'react';
import { Box, IconButton, Typography, Chip } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/**
 * Week selector with left/right arrows and a "current" chip.
 * Renders only inside KpiTab — not in the dashboard header.
 *
 * Props:
 *   weekEnding    — ISO date string of the currently-selected Sunday
 *   isCurrentWeek — boolean, true when viewing the live (most recent) week
 *   onPrev        — callback to go one week back
 *   onNext        — callback to go one week forward
 *   onCurrent     — callback to jump back to the current week
 */
const WeekNavigator = ({
  weekEnding,
  isCurrentWeek,
  onPrev,
  onNext,
  onCurrent,
}) => {
  const formatted = weekEnding
    ? new Date(weekEnding + 'T00:00:00').toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : '';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 2,
      }}
    >
      <Typography sx={{ fontSize: '12px', color: 'text.secondary', mr: 0.5 }}>
        Week ending (Sunday)
      </Typography>

      <IconButton size="small" onClick={onPrev} sx={{ p: 0.25 }}>
        <ChevronLeftIcon sx={{ fontSize: 20 }} />
      </IconButton>

      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          minWidth: 110,
          textAlign: 'center',
        }}
      >
        {formatted}
      </Typography>

      <IconButton
        size="small"
        onClick={onNext}
        disabled={isCurrentWeek}
        sx={{ p: 0.25 }}
      >
        <ChevronRightIcon sx={{ fontSize: 20 }} />
      </IconButton>

      {!isCurrentWeek && (
        <Chip
          label="current"
          size="small"
          onClick={onCurrent}
          sx={{
            ml: 0.5,
            height: 22,
            fontSize: '11px',
            fontWeight: 600,
            bgcolor: '#EF6C00',
            color: '#fff',
            cursor: 'pointer',
            '&:hover': { bgcolor: '#E65100' },
          }}
        />
      )}

      {isCurrentWeek && (
        <Chip
          label="current"
          size="small"
          sx={{
            ml: 0.5,
            height: 22,
            fontSize: '11px',
            fontWeight: 600,
            bgcolor: '#EF6C00',
            color: '#fff',
          }}
        />
      )}
    </Box>
  );
};

export default WeekNavigator;
